"use client"
import React, { useState, useEffect } from "react";

import useApi from "@/components/api/useApi";
import SetPasswordForm from "@/components/profiles/SetPasswordForm";
import { Navbar, Nav, Collapse } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

import "@/components/onboarding/AppOnboardingHeader.css";

const SetPasswordHeader = ({ show, profile }) => {
  const api = useApi();

  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const [emailAddress, setEmailAddress] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (show) {
      var storedAuth = api.getAuthentication();
      if (storedAuth != null) {
        var authentication = JSON.parse(storedAuth);
        var emailAddress = authentication.subject;
        setEmailAddress(emailAddress);
        setShowBanner(true);
      }
    }
  }, [show]);

  const dismissSetPassword = () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("SHOW_SET_PASSWORD");
    }
    setShowBanner(false);
  };

  const setPasswordFinish = success => {
    if (success && typeof window !== "undefined") {
      localStorage.removeItem("SHOW_SET_PASSWORD");
    }
    setShowBanner(false);
  };

  if (showBanner) {
    return (
      <>
        <Navbar
          className={`app-onboarding-navbar ${expanded ? "expanded" : ""}`}
          onClick={() => setExpanded(!expanded)}
        >
          <h4>Please set a password.</h4>
          <div className="expand-icon">
            {expanded && (
              <span
                className="material-icons"
                style={{ color: expanded ? "#090B0B" : "#FFFFFF" }}
              >
                expand_less
              </span>
            )}
            {!expanded && (
              <span
                className="material-icons"
                style={{ color: expanded ? "#090B0B" : "#FFFFFF" }}
              >
                expand_more
              </span>
            )}
          </div>
          <div className="flex-grow" />
          {!expanded && (
            <Nav.Link
              onClick={() => {
                dismissSetPassword();
              }}
            >
              Dismiss
            </Nav.Link>
          )}
          {expanded && (
            <div onClick={() => setExpanded(false)} style={{ cursor: "pointer" }}>
              <i className="fa-solid fa-xmark"></i>
            </div>
          )}
        </Navbar>
        <Collapse in={expanded}>
          <div className="app-onboarding-steps">
            <SetPasswordForm
              emailAddress={emailAddress}
              onSave={setPasswordFinish}
            />
          </div>
        </Collapse>
      </>
    );
  } else {
    return <></>;
  }
};
export default SetPasswordHeader;
